import { parseCost, formatCost } from "./utils";

export const calculateCostSummary = (itinerary, tripData) => {
  const { tripSummary, dayWiseItinerary, costSummary } = itinerary;

  if (costSummary?.estimatedTotal) {
    return costSummary;
  }

  const currency = tripSummary?.budget?.currency || tripData?.currency || 'INR';
  const numberOfDays = dayWiseItinerary?.length || 1;
  const adults = tripSummary?.travelers?.adults || tripData?.adults || 1;
  const children = tripSummary?.travelers?.children || tripData?.children || 0;
  const infants = tripSummary?.travelers?.infants || tripData?.infants || 0;
  const travelers = adults + children + infants || 1;

  let totalAccommodation = 0;
  let totalFood = 0;
  let totalActivities = 0;
  let totalTransport = 0;

  dayWiseItinerary?.forEach(day => {
    if (day.activities?.length > 0) {
      day.activities.forEach(activity => {
        const cost = parseCost(activity.estimatedCost);
        switch(activity.category) {
          case 'accommodation': totalAccommodation += cost; break;
          case 'dining': totalFood += cost; break;
          case 'transport': totalTransport += cost; break;
          default: totalActivities += cost;
        }
      });
    }
  });

  const total = totalAccommodation + totalFood + totalActivities + totalTransport;

  if (total === 0) return null;

  const avgPerPerson = Math.round(total / travelers);
  const adultCost = avgPerPerson;
  const childCost = Math.round(avgPerPerson * 0.65);
  const infantCost = Math.round(avgPerPerson * 0.1);

  let perPersonBreakdown = null;
  if (children > 0 || infants > 0) {
    perPersonBreakdown = {
      adult: { total: formatCost(adultCost, currency) }
    };
    if (children > 0) {
      perPersonBreakdown.child = { total: formatCost(childCost, currency) };
    }
    if (infants > 0) {
      perPersonBreakdown.infant = { total: formatCost(infantCost, currency) };
    }
  }

  return {
    estimatedTotal: formatCost(total, currency),
    perPerson: formatCost(avgPerPerson, currency),
    perPersonBreakdown,
    breakdown: {
      accommodation: formatCost(totalAccommodation, currency),
      food: formatCost(totalFood, currency),
      activities: formatCost(totalActivities, currency),
      transport: formatCost(totalTransport, currency)
    }
  };
};
